import React from 'react';
import PropTypes from 'prop-types';

import IconHeroCar from '@spothero/icons/hero-car';
import {Flex, Heading, Icon, Square, Text} from '@spothero/ui';

import MotionBox from 'common/animation/MotionBox';

const textContainerAnimationVariants = {
    collapsed: {
        opacity: 0,
        transition: {duration: 0.125, delay: 0},
    },
    expanded: {
        opacity: 1,
        transition: {duration: 0.125, delay: 0.125},
    },
};

const FacilitySidebarHeader = ({isOpen, userEmail}) => {
    return (
        <Flex
            position="relative"
            justifyContent="flex-start"
            alignItems="center"
            height={{base: 20, tablet: '5.5rem'}}
            paddingX={{base: 0, tablet: 4}}
            paddingTop={{base: 0, tablet: 8}}
            paddingBottom={{base: 0, tablet: 5}}
            gap={3}
            borderBottom={{base: 'none', tablet: '1px solid'}}
            borderColor={{base: 'transparent', tablet: 'gray.medium'}}
        >
            <Square
                size={9}
                backgroundColor="primary.default"
                borderRadius="base"
            >
                <Icon as={IconHeroCar} fill="white" boxSize={6} />
            </Square>

            <MotionBox
                variants={textContainerAnimationVariants}
                initial={false}
                animate={isOpen ? 'expanded' : 'collapsed'}
            >
                <Heading as="h1" fontSize="xs">
                    SpotHero Control Panel
                </Heading>
                <Text
                    data-testid="LoggedInUserEmail"
                    variant="caption"
                    color="text.secondary.light"
                >
                    {userEmail}
                </Text>
            </MotionBox>
        </Flex>
    );
};

FacilitySidebarHeader.propTypes = {
    isOpen: PropTypes.bool,
    userEmail: PropTypes.string,
};

export default FacilitySidebarHeader;
